var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeLine = function SvgHomeLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.75 16a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V8.118a.75.75 0 0 1 .29-.593l6-4.667a.75.75 0 0 1 .92 0l6 4.667a.75.75 0 0 1 .29.592zm-1.5-.75V8.483L10 4.4 4.75 8.484v6.767z"
  })));
};
export default SvgHomeLine;